import { Business } from "../business/types";
import { User } from "../user/types";

export interface ListRequest {
  id: number;
}

export interface BookableListRequest {
  id: number;
  date: string;
}

export interface BusinessList {
  id?: number;
  list_name: string;
  list_headline: string;
  businesses: Business[];
  user: User;
}

export enum BusinessCheckoutTabs {
  BookableItems = "Bookable Items",
  Businesses = "Businesses",
}

export interface BusinessListDTO {
  list_name: string;
  list_headline: string;
  business_ids: number[];
  user_id: number;
}
